export default {
    name: 'noData',
    props: { //验证
        title: { //数据
            type: String,
            default() {
                return '暂无数据';
            }
        },
    },
    data() {
        return {}
    },
    watch: {},
    created() {

    },
    methods: {}
}